import { render, staticRenderFns } from "./trail-alert.vue?vue&type=template&id=67a899e4&scoped=true&"
import script from "./trail-alert.vue?vue&type=script&lang=ts&"
export * from "./trail-alert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a899e4",
  null
  
)

export default component.exports